const loginUrl = {
  path: `${process.env.APP_URL}/entrar`
}

const registerUrl = {
  path: `${process.env.APP_URL}/cadastrar`
}

const landing = {
  name: 'LandingController',
  data () {
    return {
      loginUrl,
      registerUrl
    }
  },
  methods: {
    cadastroClique(){
      gtag('event', 'cadastro', {
      'event_category': 'clique'
      });
    }
  }
}

export default landing



// WEBPACK FOOTER //
// ./src/components/Views/Landing.js